import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Realms extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/security/realm'
    super(store, path)
  }
  list(showProgress) {
    return this._request({
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
}
